import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    overflow: hidden;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React, { useRef } from 'react';
import styled from 'styled-components';
import { useElementSize } from '../../hooks/useElementSize';
import { useStep } from '../../hooks/useStep';
import { trail, fromTo, val } from 'light-trails';
export const Expand = props => {
  const direction = props.horizontal ? 'width' : 'height';
  const ref = useRef(null);
  const size = useElementSize(ref);
  useStep(props.in, ({
    duration
  }) => trail(ref.current, [fromTo({
    opacity: val(0, 1),
    [direction]: val(0, size[direction], 'px')
  }, duration.normal)]), {
    title: '→Expand',
    deps: [size !== null]
  });
  useStep(props.out, ({
    duration
  }) => trail(ref.current, [fromTo({
    opacity: val(1, 0),
    [direction]: val(size[direction], 0, 'px')
  }, duration.normal)]), {
    title: '←Expand'
  });
  return React.createElement(Container, {
    ref: ref
  }, props.children);
};
const Container = styled.div(_templateObject());